export const uploadCustomDeviceImage = async (deviceType: "DEVICE" | "LS" | "SS", file: File, deviceId: string) => {
    if (file == null) {
        return;
    }

    let fileUploadEndpoint = "";
    if (deviceType === "DEVICE") {
        fileUploadEndpoint = `/DeviceImageUpload.ashx?FileName=${deviceId}`;
    } else if (deviceType === "LS") {
        fileUploadEndpoint = `/LogicSolverImageUpload.ashx?FileName=${deviceId}`;
    } else if (deviceType === "SS") {
        fileUploadEndpoint = `/imageupload.ashx?FileName=${deviceId}`;
    }

    try {
        const formData = new FormData();
        formData.append(file.name, file);
        const response = await fetch(fileUploadEndpoint, {
            method: "POST",
            body: formData
        });
        await response.json();
        return;
    } catch (error) {
        console.log(error);
        return;
    }
}